!(function(){
	var main = function(){

		var mobileMenuButton = _dom('.mobileMenuIcon')[0],
			contentSlder = _dom(".contentMenuSlider")[0];


		contentSlder.animationDuration(200);
		var menu = {
			isShow: false,

			show: function(){
				contentSlder.transform({
					y: 0,
					x: 250
				});
				mobileMenu.isShow = true;
				menu.isShow = true;
			},

			hide: function(){
				contentSlder.transform({
					y: 0,
					x: 0
				});
				mobileMenu.isShow = false;
				menu.isShow = false;

				contentSlder.off('tap', menu.hide);
			},

			toggle: function(){
				if(menu.isShow){
					menu.hide();
				}else{
					menu.show();
				}
			}
		};

		_dom('#catalogMenu').on('tap', function(){
			menu.toggle();
			contentSlder.on('tap', menu.hide);
			if(typeof slide !== 'undefined'){
				slide.once('position:change', menu.hide);
			}
		});

		var mobileMenu = {
			isShow: false,

			show: function(){
				contentSlder.transform({
					y: 0,
					x: window.innerWidth*0.63
				});
				mobileMenu.isShow = true;
				menu.isShow = true;
			},

			hide: function(){
				contentSlder.transform({
					y: 0,
					x: 0
				});
				mobileMenu.isShow = false;
				menu.isShow = false;
				contentSlder.off('tap', mobileMenu.hide);
			},

			toggle: function(){
				if(mobileMenu.isShow){
					mobileMenu.hide();
				}else{
					mobileMenu.show();
				}
			}
		};


		Hammer(mobileMenuButton.el,{
			prevent_default: true
		}).on('tap', function(event){
			event.stopPropagation();
			mobileMenu.toggle();
			contentSlder.on('tap', mobileMenu.hide);
		});


		_dom(window).on('orientationchange', function(){
			if(mobileMenu.isShow)mobileMenu.show();
		});

	};
	if(!!window.addEventListener){
		window.addEventListener('load', main);
	}else{
		window.attachEvent('onload', main);
	}
})();